import angular from 'angular';
import {
  loaderService,
  ssDialogService,
  vmDataService,
} from 'app/services';
import editMasterVendorDialog from './masterVendors/editMasterVendorDialog';
import MasterVendors from './masterVendors';
import VendorManagementAdminDirectiveController from './vendor-management-admin.directive.controller';
import vendorManagementAdminDirective from './vendor-management-admin.directive';


export const vendorManagementAdminRouteConfig = {
  template: require('./vendor-management-admin.directive.html'),
  controller: 'VendorManagementAdminDirectiveController',
  controllerAs: 'vendorManagementAdminVM',
};

export default angular.module('app.components.admin.vendorManagementAdmin', [
  MasterVendors,
  editMasterVendorDialog,
  loaderService,
  ssDialogService,
  vmDataService,
])
  .directive('vendorManagementAdmin', vendorManagementAdminDirective)
  .controller('VendorManagementAdminDirectiveController', VendorManagementAdminDirectiveController)
  .name;

console.log('app.components.admin.vendorManagementAdmin created');
